<template>
  <div class="selecttree">
    <el-select
      class="main-select-tree"
      ref="selectTree"
      v-model="value"
      style="width: 100%"
      :disabled="disabled"
      @change="handleChangeSelect"
    >
      <el-option
        v-for="item in formatData(list)"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        style="display: none"
      />
      <el-tree
        class="main-select-el-tree"
        ref="selecteltree"
        :data="list"
        :node-key="rowKey"
        highlight-current
        :props="defaultProps"
        @node-click="handleNodeClick"
        :current-node-key="value"
        :expand-on-click-node="expandOnClickNode"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "setValue",
  },
  props: {
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 传入嵌套数据
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    value: [String, Number],
    rowKey: {
      type: String,
      default: "id",
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: "children",
          label: "name",
        };
      },
    },
  },
  data() {
    return {
      expandOnClickNode: true,
    };
  },
  methods: {
    // 四级菜单
    formatData(data) {
      let options = [];
      data.forEach((item, key) => {
        options.push({
          label: item[this.defaultProps.label],
          value: item[this.rowKey],
        });
        if (item[this.defaultProps.children]) {
          item[this.defaultProps.children].forEach((items, keys) => {
            options.push({
              label: items[this.defaultProps.label],
              value: items[this.rowKey],
            });
            if (items[this.defaultProps.children]) {
              items[this.defaultProps.children].forEach((itemss, keyss) => {
                options.push({
                  label: itemss[this.defaultProps.label],
                  value: itemss[this.rowKey],
                });
                if (itemss[this.defaultProps.children]) {
                  itemss[this.defaultProps.children].forEach(
                    (itemsss, keysss) => {
                      options.push({
                        label: itemsss[this.defaultProps.label],
                        value: itemsss[this.rowKey],
                      });
                    }
                  );
                }
              });
            }
          });
        }
      });
      return options;
    },
    handleNodeClick(node) {
      if (!node.children || (node.children && node.children.length == 0)) {
        this.$emit("setValue", node.id);
        this.$refs.selectTree.blur();
        this.$emit("change");
      }
    },
    handleChangeSelect() {
      this.$emit("change");
    },
  },
};
</script>
<style>
.main-select-el-tree .el-tree-node .is-current > .el-tree-node__content {
  font-weight: bold;
  color: #409eff;
}
.main-select-el-tree .el-tree-node.is-current > .el-tree-node__content {
  font-weight: bold;
  color: #409eff;
}
</style>
